module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-58ec17fc371ab3a3c24d985b2318b50a.jpg";